module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Bloom-menu', {
    staticClass: "menu-left-corner-wrapper",
    attrs: {
      "iconImgArr": _vm.iconImgArr,
      "startAngle": -90,
      "endAngle": 0,
      "itemNum": 4
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-loader/10.3.0/vue-loader/lib/template-compiler.js?id=data-v-b90aa47e!./~/.npminstall/vue-loader/10.3.0/vue-loader/lib/selector.js?type=template&index=0!./src/Corner.vue
// module id = 32
// module chunks = 1